<template>
  <div class="app flex-row align-items-center" id="registerSafePlaceUser-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3">
          <h3 style="color: white; font-family: 'Times New Roman'">
            BỘ VĂN HÓA, THỂ THAO VÀ DU LỊCH
          </h3>
          <h2
            style="
              color: white;
              font-weight: 700;
              font-family: 'Times New Roman';
            "
          >
            CỤC DU LỊCH QUỐC GIA VIỆT NAM
          </h2>
          <img src="img/logo_VN.png" style="transform: scale(0.7)" alt />
          <!-- <h2
            style="
              color: #fff200;
              margin-top: 10px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            CHƯƠNG TRÌNH
          </h2>
          <h3
            class="title"
            style="
              color: #fff200;
              margin-bottom: 20px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            KÍCH CẦU DU LỊCH NỘI ĐỊA - DU LỊCH VIỆT NAM AN TOÀN, HẤP DẪN
          </h3> -->
        </b-col>
        <b-col md="8" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h4 class="text-center" style="font-weight: bold">ĐĂNG KÝ</h4>
                <h4 class="text-center" style="font-weight: bold">
                  HỆ THỐNG CƠ SỞ DỮ LIỆU DU LỊCH VIỆT NAM
                </h4>
                <h6
                  class="text-center mb-3"
                  style="font-weight: bold; color: red"
                >
                  Tất cả các trường có dấu (*) bắt buộc phải khai báo thông tin
                </h6>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertSuccess = false
                  "
                  >{{ mData.dataDefault.success }}</b-alert
                >

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                  class="mt-1"
                >
                  <!-- <el-form-item label prop="email" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-user"
                      placeholder="Email*"
                      v-model.trim="mData.dataForm.email"
                      autocomplete="off"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="pass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-unlock"
                      placeholder="Mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.pass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="repass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-lock"
                      placeholder="Gõ lại mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.repass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>-->
                  <el-form-item label prop="ten" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Tên điểm đến*"
                      v-model="mData.dataForm.ten"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="tinh_id">
                    <el-select
                      @change="changeProvinceHandler"
                      v-model="mData.dataForm.tinh_id"
                      placeholder="Tỉnh/Thành phố*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.provinceList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="" prop="huyen_id">
                    <el-select
                      @change="changeDistrictHandler"
                      v-model="mData.dataForm.huyen_id"
                      placeholder="Quận/Huyện*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.districtList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                  <el-form-item label="" prop="xa_id">
                    <el-select
                      v-model="mData.dataForm.xa_id"
                      placeholder="Phường/Xã*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.communeList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="dia_chi"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-location"
                      placeholder="Địa chỉ đơn vị*"
                      v-model="mData.dataForm.dia_chi"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="ho_ten"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Họ tên người đăng ký*"
                      v-model="mData.dataForm.ho_ten"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="chuc_vu"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Chức vụ*"
                      v-model="mData.dataForm.chuc_vu"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="dien_thoai"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-phone"
                      placeholder="Số điện thoại di động người đăng ký*"
                      v-model="mData.dataForm.dien_thoai"
                      clearable
                    ></el-input>
                    <span class="text-danger mb-2">
                      *Hiện tại hệ thống mới hỗ trợ các nhà mạng viettel,
                      mobifone, vinaphone.
                    </span>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="so_giay_to"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-postcard"
                      placeholder="Số CMTND/CCCD/Hộ chiếu người đăng ký*"
                      v-model="mData.dataForm.so_giay_to"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="loai" class="el-form-item--medium">
                    <el-select
                      @change="selectLoai"
                      v-model="mData.dataForm.loai"
                      :placeholder="'Chọn loại hình*'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listLoaiHinh"
                        :key="item.code"
                        :label="item.text"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="mData.dataDefault.stateLoai"
                    prop="khach_san_so_sao"
                  >
                    <!-- <el-select multiple filterable v-model="hi" placeholder="Select">
                      <el-option
                        v-for="item in this.mData.dataDefault.listCSLTDichVu"
                        :key="item.id"
                        :label="item.id"
                        :value="item.id">
                      </el-option>
                    </el-select> -->
                    <el-select
                      v-model="mData.dataForm.khach_san_so_sao"
                      placeholder="Xếp hạng*"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listXepHang"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="mData.dataDefault.stateLoai"
                    prop="cslt_dichvu"
                  >
                    <!-- <el-select multiple filterable v-model="hi" placeholder="Select">
                      <el-option
                        v-for="item in this.mData.dataDefault.listCSLTDichVu"
                        :key="item.id"
                        :label="item.id"
                        :value="item.id">
                      </el-option>
                    </el-select> -->
                    <el-select
                      v-model="mData.dataForm.cslt_dichvu"
                      multiple
                      placeholder="Chọn tiện nghi*"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listCSLTDichVu"
                        :key="item.id"
                        :label="item.ten.vi"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- multi -->
                  <el-form-item label prop="email" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Email*"
                      v-model="mData.dataForm.email"
                      clearable
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label
                    prop="ma_so_thue"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Mã số thuế (Không bắt buộc)"
                      v-model="mData.dataForm.ma_so_thue"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="website"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Website (Không bắt buộc)"
                      v-model="mData.dataForm.website"
                      clearable
                    ></el-input>
                  </el-form-item>

                  <!-- <el-form-item label prop="challenge_token" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-phone"
                      placeholder="Challenge Token"
                      v-model="mData.dataForm.challenge_token"
                      clearable
                      name="recaptcha" id="recaptcha"
                    ></el-input>
                  </el-form-item>-->
                  <el-form-item class="text-left">
                    <div class="dieu-khoan">
                      <el-checkbox v-model="agreeTerms">
                        Đồng ý với các điều khoản tham gia Trang vàng du lịch
                      </el-checkbox>
                      <el-collapse>
                        <el-collapse-item class="hai" name="1">
                          <template slot="title">
                            <p class="mb-0">
                              Điều khoản
                              <span class="bold trang-vang"
                                >Trang vàng du lịch</span
                              >
                            </p>
                          </template>
                          <div>
                            <div class="text__header text-center">
                              <h5>
                                Tiêu chí tham gia Trang vàng Du lịch Việt Nam
                              </h5>
                            </div>
                            <div class="content">
                              <p class="mb-0">
                                1. Tự nguyện đăng ký tham gia chương trình Du
                                lịch Việt Nam an toàn. Tuân thủ Bộ Quy tắc Ứng
                                xử văn minh du lịch do Bộ Văn hóa, Thể thao và
                                Du lịch ban hành
                                <span class="bold link" @click="openFile"
                                  >QĐ718 – 2017.pdf</span
                                >
                              </p>
                              <p class="mb-0">
                                2. Thực hiện Chế độ báo cáo thống kê du lịch ban
                                hành theo Thông tư số
                                <span class="bold link" @click="downloadFile"
                                  >18/2021/TT-BVHTTDL</span
                                >
                                ngày 31/12/2021 của Bộ Văn hóa, Thể thao và Du
                                lịch
                              </p>
                              <p class="mb-0">
                                3. Niêm yết giá hàng hóa, dịch vụ công khai
                              </p>
                              <p class="mb-0">
                                4. Chấp nhận thanh toán điện tử, giao dịch sử
                                dụng
                                <span class="bold link" @click="openLink"
                                  >Thẻ du lịch</span
                                >
                              </p>
                              <p class="mb-0">
                                5. Cam kết sản phẩm, dịch vụ đảm bảo chất lượng,
                                có chương trình ưu đãi cho khách du lịch
                              </p>
                              <p class="mb-0">
                                6. Có trách nhiệm tiếp nhận và giải quyết khiếu
                                nại, phản ánh của khách du lịch qua ứng dụng Du
                                lịch Việt Nam
                              </p>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </el-form-item>
                  <el-form-item class="text-center">
                    <el-button
                      :loading="isLoading"
                      :disabled="!agreeTerms"
                      type="success"
                      @click="fn_submitForm()"
                      native-type="submit"
                    >
                      Đăng ký
                    </el-button>
                  </el-form-item>
                </el-form>

                <!-- <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>-->
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="12" class="text-center mt-3">
          <h5
            style="
              color: white;
              margin-bottom: 5px;
              font-family: 'Times New Roman';
            "
          >
            THÔNG TIN LIÊN HỆ, HỖ TRỢ:
          </h5>
          <p class="text" style="color: white; font-family: 'Times New Roman'">
            Điện thoại:
            <a style="color: #ffffff" href="tel:19006888">1900 6888</a>; Email:
            <a style="color: #ffffff" href="mailto:info@vietsens.vn"
              >info@vietsens.vn</a
            >;
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<!--<script src="https://www.google.com/recaptcha/api.js?render=6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19"></script>
<script>
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19', {
            action: 'contact'
        }).then(function(token) {
            if (token) {
                document.getElementById('recaptcha').value = token;
            }
        });
    });
</script>-->
<!--<script>
export default {
  name: 'Register'
}
</script>-->

<script>
import AccountApi from "../../moduleApi/AccountApi";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import DataService from "../../service/DataService";
import AuthService from "../../service/AuthService";
import ProvinceApi from "../../moduleApi/ProvinceApi";
import DistrictApi from "../../moduleApi/DistrictApi";
import CommuneApi from "../../moduleApi/CommuneApi";
import CSLTDichVu from "../../moduleApi/CSLTDichVu";
import DiemDenAnToanApi from "../../moduleApi/DiemDenAnToanApi";
import ExtensionService from "../../service/ExtensionService";

let firstProvince = {
  id: "",
  type: "",
  name: "Chọn tỉnh/thành phố",
  code: "",
};
let firstDistrict = {
  id: "",
  type: "",
  name: "Chọn quận/huyện",
  code: "",
};
let firstCommune = {
  id: "",
  type: "",
  name: "Chọn phường/xã",
  code: "",
};

export default {
  data() {
    return {
      agreeTerms: false,
      isLoading: false,
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          // site_key:'',
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          provinceList: [],
          districtList: [],
          communeList: [],
          listCSLTDichVu: [],
          loai: [
            "entertainment",
            "international_travel",
            "tourist_carriers",
            "domestic_travel",
            "shopping",
            "restaurant",
            "tourist_area",
            "tourist_attraction",
            "state_management_agency",
            "others",
          ],
          stateLoai: false,
          listXepHang: DataService.listXepHang,
        },
        dataForm: {
          // email: "",
          // pass: "",
          // repass: "",
          ten: "",
          dien_thoai: "",
          tinh_id: "",
          xa_id: "",
          dia_chi: "",
          so_giay_to: "",
          loai: "",
          nguon: "web",
          cslt_dichvu: null,
          khach_san_so_sao: null,
          // gioi_tinh: "",
          // challenge_token: ""
        },
        validForm: {
          // email: [ValidService.required, ValidService.checkEmail],
          // pass: [ValidService.required, ValidService.checkLength(6)],
          // repass: [ValidService.required, ValidService.checkLength(6)],
          ten: [ValidService.requiredChange],
          dien_thoai: [ValidService.requiredChange, ValidService.checkPhone],
          dia_chi: [ValidService.requiredChange],
          so_giay_to: [
            ValidService.requiredChange,
            ValidService.pattern(
              /^[0-9a-zA-Z]*$/,
              "Giá trị không hợp lệ! Chỉ chấp nhận chữ số, chữ cái."
            ),
          ],
          loai: [ValidService.requiredChange],
          tinh_id: [ValidService.requiredChange],
          xa_id: [ValidService.requiredChange],
          cslt_dichvu: [ValidService.required, ValidService.requiredChange],
          khach_san_so_sao: [
            ValidService.required,
            ValidService.requiredChange,
          ],
          ho_ten: [ValidService.requiredChange],
          chuc_vu: [ValidService.requiredChange],
          email: [ValidService.required, ValidService.checkEmail],
          // gioi_tinh: [],
          // challenge_token: []
        },
      },
    };
  },
  methods: {
    openLink() {
      window.open("http://thedulich.gov.vn/", "_blank").focus();
    },
    openFile() {
      window
        .open(ExtensionService.urlFilesTemplate.QĐ718_2017, "_blank")
        .focus();
    },
    downloadFile() {
      var a = document.createElement("a");
      a.href = ExtensionService.urlFilesTemplate.TT262014BVHTTDL;
      a.download = "TT262014BVHTTDL.pdf";
      a.click();
    },
    selectLoai() {
      if (
        this.mData.dataDefault.loai.includes(this.mData.dataForm.loai) == false
      ) {
        this.mData.dataDefault.stateLoai = true;
      } else {
        this.mData.dataDefault.stateLoai = false;
      }
    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        this.isLoading = true
        if (valid) {
          this.mData.dataForm.dien_thoai =
            "84" +
            this.mData.dataForm.dien_thoai.substring(
              this.mData.dataForm.dien_thoai.length - 9
            );

          // debugger;
          AccountApi.registerSafePlaceUser(this.mData.dataForm)
            .then(async (res) => {
              try {
                await AuthService.login(
                  res.result.account,
                  res.result.password,
                  false
                );
                let messageSuccess =
                  `<p>Đăng ký thành công, thông tin tài khoản đăng nhập đã được gửi về số điện thoại "${
                    "0" + this.mData.dataForm.dien_thoai.substring(2)
                  }". Vui lòng kiểm tra tin nhắn!</p>` +
                  `<p style="margin-top:10px;">Vui lòng liên hệ 19006888 để được hỗ trợ nếu không nhận được tin nhắn thông báo OTP!</p>`;
                this.$alert(messageSuccess, ``, {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "OK",
                  callback: (action) => {
                    if (
                      this.mData.dataDefault.loai.includes(
                        this.mData.dataForm.loai
                      )
                    ) {
                      this.redirectToForm(res.result.id);
                    } else {
                      this.$router.push({ name: "Admin-DangKyDDAT" });
                    }
                  },
                });
                this.isLoading = false
              } catch (error) {
                this.mData.dataDefault.showDismissibleAlert = true;
                this.mData.dataDefault.error = LanguageService.lang.login_error;
                this.isLoading = false
              }
            })
            .catch((error) => {
              this.mData.dataDefault.showDismissibleAlert = true;
              console.log("ERROR : ", error.toString());
              if (error.code == 401 && error.subCode == 140) {
                this.mData.dataDefault.error =
                  "Mã số thuế này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
                toastr.error("Mã số thuế này đã đăng ký");
              } else if (error.code == 401 && error.subCode == 141) {
                toastr.error("Tên điểm đến và Địa chỉ này đã đăng ký");
                this.mData.dataDefault.error =
                  "Tên điểm đến và Địa chỉ này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
              } else if (error.code == 401 && error.subCode == 142) {
                toastr.error("Tên điểm đến và Xã này đã đăng ký");
                this.mData.dataDefault.error =
                  "Tên điểm đến và Xã này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
              } else if (error.code == 401 && error.subCode == 143) {
                toastr.error(" Số điện thoại này đã được đăng ký");
                this.mData.dataDefault.error =
                  `Số điện thoại ` +
                  (this.mData.dataForm.dien_thoai.substring(0, 2) == 84
                    ? this.mData.dataForm.dien_thoai.replace(/^\d{2}/, "0")
                    : this.mData.dataForm.dien_thoai) +
                  ` đã được đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.`;
              } else {
                this.mData.dataDefault.error =
                  "Đăng ký người dùng không thành công";
                toastr.error("Đăng ký người dùng không thành công");
              }
              this.isLoading = false
            });
        } else {
          MethodService.stopLadda();
          this.isLoading = false
          return false;
        }
      });
      console.log("thisthis.mData.dataForm", this.mData.dataForm);
    },
    async redirectToForm(id) {
      let dataFilter = {
        filters: "nguoi_tao_id:in:" + id,
      };
      let ddat = await DiemDenAnToanApi.list(dataFilter);
      if (ddat.result.length > 0) {
        this.$router.push({
          name: "Admin-DangKyDDAT-update",
          params: { id: ddat.result[0].id },
        });
      }
    },
    async getProvinceList() {
      try {
        const provinceList = await ProvinceApi.list({
          limit: 200,
          sort: "type,index",
        });
        provinceList.result.unshift(firstProvince);
        this.mData.dataDefault.provinceList = provinceList.result;
      } catch (error) {
        console.log("error", error);
      }

      try {
        const listCSLTDichVu = await CSLTDichVu.list();
        this.mData.dataDefault.listCSLTDichVu = listCSLTDichVu.result;
        // console.log(`{{ this.mData.dataDefault.listCSLTDichVu: }}`,this.mData.dataDefault.listCSLTDichVu)
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // async getDistrictList(provinceId) {
    //   if (!provinceId) {
    //     this.mData.dataDefault.districtList = [firstDistrict];
    //     return;
    //   }
    //   try {
    //     if (provinceId) {
    //       const districtList = await DistrictApi.list({
    //         filters: [`provinceId=${provinceId}`],
    //         limit: 200,
    //       });
    //       districtList.result.unshift(firstDistrict);
    //       this.mData.dataDefault.districtList = districtList.result;
    //     }
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
    async getCommuneList(provinceId) {
      if (!provinceId) {
        this.mData.dataDefault.communeList = [firstCommune];
        return;
      }
      try {
        if (provinceId) {
          const communeList = await CommuneApi.list({
            filters: [`provinceId=${provinceId}`],
            fields: "id,name,code,type",
            limit: 200,
          });
          communeList.result.unshift(firstCommune);
          this.mData.dataDefault.communeList = communeList.result;
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    changeProvinceHandler(province) {
      // this.mData.dataDefault.districtList = [firstDistrict];
      this.mData.dataDefault.communeList = [firstCommune];
      this.mData.dataForm.xa_id = "";

      this.getCommuneList(province);
    },
    // changeDistrictHandler(district) {
    //   this.mData.dataDefault.communeList = [firstCommune];
    //   this.mData.dataForm.xa_id = "";

    //   this.getCommuneList(district);
    // },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "register".
      const token = await this.$recaptcha("register");
      this.mData.dataForm.challenge_token = token;

      // Do stuff with the received token.
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    async fn_initData() {
      // let resSitekey = await CauHinhApi.list({ filters: "code:in:site_key_captcha" });
      // if (resSitekey) {
      //   this.mData.dataDefault.site_key = resSitekey.result[0].value;
      // }
      // this.recaptcha();

      await this.getProvinceList();
    },
    fn_goDangNhap() {
      this.$router.push({
        name: "Auth",
        // query: {
        //   filters: "doi_tuong_danh_gia_id:in:" + row.id
        // }
      });
    },
    fn_go() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.fn_initData();
  },
  created() {},
};
</script>
<style scoped lang="scss">
#registerSafePlaceUser-page {
  background-image: url("~/img/background.jpg");
  background-size: cover;
  .el-form-item--mini,
  .el-form-item--small {
    &.el-form-item {
      margin-bottom: 25px;
    }
    .el-form-item__error {
      margin-top: 10px;
    }
  }
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: black;
  font-weight: 400;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #fff;
}
::v-deep .el-collapse {
  border: none;
}
.trang-vang {
  color: #409eff;
}
::v-deep .el-collapse-item__header {
  background-color: #fff;
  border: none;
}
::v-deep .hai > div:first-child {
  width: 232px;
}
::v-deep .el-checkbox {
  display: flex;
  align-items: center;
}
::v-deep .el-collapse-item__wrap {
  border: none;
}
::v-deep .el-collapse-item__wrap .el-collapse-item__content {
  border: none;
}
::v-deep .el-checkbox__label {
  word-break: break-word;
  white-space: normal;
  margin-bottom: 5px;
}
.link {
  color: #409eff;
}
@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  .text {
    font-size: 12px;
  }
}
</style>
<style lang="scss">
@media (max-width: 460px) {
  .el-message-box__wrapper {
    .el-message-box {
      width: 70% !important;
    }
  }
}
</style>
